module.exports = __webpack_public_path__ + "register/img/us.c22e6f33.svg";